import React, { Component, Fragment } from "react";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";
import Modal from "./../../../components/modalComponent/ModalComponent";
import ImportFormContainer from "../../ImportFormContainer";
class Import extends Component {
	state = { showModal: false };
	render() {
		return (
			<Fragment>
				<Modal
					title="Import modèles MEA/PLV"
					showModal={this.state.showModal}
					closeModal={() => this.setState({ showModal: false })}
					{...this.props}
				>
					<div>
						<ImportFormContainer
							{...this.props}
							title="Modèles MEA/PLV"
							importUri={"model_merch"}
						/>
					</div>
				</Modal>
				<div class="p-mrg-right">
					<ConfirmButton
						label="Importer des modèles MEA/PLV"
						large={true}
						onClick={() => this.setState({ showModal: true })}
					/>
				</div>
			</Fragment>
		);
	}
}
export default Import;



// WEBPACK FOOTER //
// src/containers/admin/merch/Import.js